module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Thin-WebM-3ef35ba1076c6965ec5d83669e740606.woff2";